import { SvgIcon, Typography } from "@mui/material";

import { FootprintsIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

import { NightReportMetric } from "interfaces/nightReport.interface";

import { MetricBadge } from "../../../../../NightReportScreen/components/MetricBadge";
import { StatCard } from "../components/StatCard";

type OutOfBedCardProps = {
  timesOutOfBed: string;
  timesOutOfBedMetric: NightReportMetric | null;
};

export function OutOfBedCard({
  timesOutOfBed,
  timesOutOfBedMetric,
}: OutOfBedCardProps) {
  const { t } = useTranslation();

  return (
    <StatCard>
      <SvgIcon component={FootprintsIcon} color={"neutral.decoration"} />
      <Typography
        variant={"bodySmallMedium"}
        sx={{
          color: "neutral.subtle",
        }}
      >
        {t("Out of Bed")}
      </Typography>
      <Typography variant={"headingLargeRegular"}>{timesOutOfBed}</Typography>
      {timesOutOfBedMetric?.deviation && (
        <MetricBadge
          metric={timesOutOfBedMetric}
          alertMetric={"time_asleep"}
          delta={timesOutOfBedMetric.baseline ?? 0}
          sx={{ alignSelf: "self-start" }}
        />
      )}
    </StatCard>
  );
}
